import { render, staticRenderFns } from "./VoiceClone.vue?vue&type=template&id=418ebb88&scoped=true&"
import script from "./VoiceClone.vue?vue&type=script&lang=js&"
export * from "./VoiceClone.vue?vue&type=script&lang=js&"
import style0 from "./VoiceClone.vue?vue&type=style&index=0&id=418ebb88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418ebb88",
  null
  
)

export default component.exports